import Relay from 'react-relay/classic';
import networkLayer from '../global/relayClientNetworkLayer.es';

const relayEnvironmentProvider = () => {
    let environment = null;

    return {
        getEnvironment() {
            if (!environment) {
                environment = Relay.Store;
                environment.injectNetworkLayer(networkLayer());
            }
            return environment;
        },
    };
};

const provider = relayEnvironmentProvider();
const { getEnvironment } = provider;

export { getEnvironment };
export default provider;



// WEBPACK FOOTER //
// ./assets/js/global/relayEnvironmnentProvider.es.js